import PropTypes from 'prop-types';
import React from 'react';

import { Dialog, DialogContent, DialogTitle, Divider, Typography } from 'components/AORedesign';

const reportTypes = ['GlassProgram', 'TotalLoss', 'MethodOfInspection', 'PropertyClaims', 'WorkersCompensation'];

export const REPORT_A_CLAIM_DIALOG_CONTENT_MAP = Object.fromEntries(reportTypes.map((key) => [key, key]));

const ClaimsReportingModal = ({ claimsReportingModalContent, handleCloseClaimsReportingModal }) => {
  const renderTitle = () => {
    if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.GlassProgram) {
      return 'Glass Program';
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.TotalLoss) {
      return 'Navigating a Total Loss';
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.MethodOfInspection) {
      return 'Method of Inspection and Auto Repair Options';
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.PropertyClaims) {
      return 'Property Claims After Hours Emergency Response';
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.WorkersCompensation) {
      return "Workers' Compensation Claims";
    }
  };

  const renderContent = () => {
    if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.GlassProgram) {
      return (
        <>
          <Typography style={{ marginBottom: 16 }}>
            Make auto glass repairs quick and easy for your customers with the Main Street America Insurance Glass Program. The Glass Program is administered by
            Safelite, an industry leader in glass repair, and offers access to more than 10,000 glass repair shops to ensure a convenient location for every
            customer. With utilization of our Glass Program, our team will make repair and payment arrangements and handle processing through Safelite, so
            there&#39;s no hassle for your customers!
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            As an added bonus, when your customer uses a Safelite Preferred facility, they&#39;re automatically enrolled in our extended lifetime warranty
            program.
          </Typography>
          <Typography>To report a glass claim:</Typography>
          <Typography style={{ marginBottom: 16 }}>Call 800.887.5944</Typography>
          <Typography>Any claims paid out of pocket by the customer should be reported to our Central Glass Team.</Typography>
          <Typography>Phone: 833.981.3710</Typography>
          <Typography>Email: centralglassteam@afi cs.com</Typography>
          <Typography>Fax: 866.383.8769</Typography>
        </>
      );
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.TotalLoss) {
      return (
        <>
          <Typography style={{ marginBottom: 16 }}>
            Total loss is when the cost of repairs, open items and the anticipated salvage value exceeds the vehicle&#39;s actual cash value (ACV). Main Street
            America Insurance partners with CCC Information services to leverage their total loss evaluation technology in our settlement process.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            How It Works: We use CCC&#39;s local market surveys to determine the ACV of your customer&#39;s vehicle. Then a condition rating, looking at the
            vehicle&#39;s mileage, condition and unrelated damage, is used to determine a fair ACV at the time of loss.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            You can rest assured that Main Street America Insurance conforms to all state regulations for handling a total loss and uses multiple evaluation
            sources when necessary.
          </Typography>
          <Typography>
            All total losses are settled by a claims adjusting team with all the expertise needed to ensure a positive experience for your customer.
          </Typography>
        </>
      );
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.MethodOfInspection) {
      return (
        <>
          <Typography style={{ marginBottom: 16 }}>
            The Main Street America Insurance Method of Inspection Auto Repair Options help you provide better, more personal service to your customers through
            easy, convenient car repairs. Your customers have three repair options:
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            Value In Partnership (VIP): This program is intended to maximize customer satisfaction, reduce service time delivery and lower overall expense
            through a network of preferred, quality-focused collision repair facilities.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            Photo Estimating: CVP (Claim Virtual Photo estimating) offers customers the option to capture claims information from their smartphone, by
            collecting photos and sharing information through a self-guided experience.
          </Typography>
          <Typography>
            Open Shop: This inspection channel is used when a vehicle owner prefers to partner with an out-of-network repair center of their choice.
          </Typography>
        </>
      );
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.PropertyClaims) {
      return (
        <>
          <Typography style={{ marginBottom: 16 }}>After-Hours Emergency Response</Typography>
          <Typography style={{ marginBottom: 16 }}>
            Emergencies can&#39;t always be avoided. Main Street America Insurance is ready to help with after-hours service providers who can guide your
            customer through the claims process for any emergency commercial and homeowners property losses. Simply call 877.4CLAIMS (425.2467) any time, day or
            night, and our provider will gather all the necessary information and reach out to an adjuster.
          </Typography>
        </>
      );
    } else if (claimsReportingModalContent === REPORT_A_CLAIM_DIALOG_CONTENT_MAP.WorkersCompensation) {
      return (
        <>
          <Typography style={{ marginBottom: 16 }}>Managing Medical Care</Typography>
          <Typography style={{ marginBottom: 16 }}>
            Our workers&#39; compensation team is ready to provide comprehensive management with an added focus on ensuring quality medical care. Timely
            reporting is important - we recommend your commercial customer report any claims the same day of the injury or as soon as they are made aware.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            To ensure a safe, productive transition back to work, we will coordinate with the employer, injured worker and medical team to create a customized
            return-to-work plan based on the employee&#39;s needs.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>To ensure the best price, we also offer:</Typography>
          <Typography style={{ marginBottom: 16 }}>
            Medical Bill Review - Helps control expenses through state fee schedules and reductions, and identifies billing errors or fraud.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            Prescription Services - Available to new and long-term cases and includes reviews to control prescription drug costs.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>
            Medical Case Management - Assists the injured worker through the medical process and works with medical providers to ensure the best treatment.
          </Typography>
          <Typography style={{ marginBottom: 16 }}>Vocational Case Management - Helps the injured employee get back to work.</Typography>
          <Typography style={{ marginBottom: 16 }}>Partnership with Medical Provider Networks</Typography>
        </>
      );
    }
  };

  return (
    <Dialog
      open={claimsReportingModalContent?.length > 0 ? true : false}
      onClose={handleCloseClaimsReportingModal}
      aria-labelledby="claims-reporting-modal-title"
      aria-describedby="claims-reporting-modal-description">
      <DialogTitle>
        <Typography variant="h4">{renderTitle()}</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>{renderContent()}</DialogContent>
    </Dialog>
  );
};

ClaimsReportingModal.propTypes = {
  claimsReportingModalContent: PropTypes.string,
  handleCloseClaimsReportingModal: PropTypes.func,
};

export default ClaimsReportingModal;
